<app-header [forceLightBackground]="true"></app-header>
<section class="contact-us">
  <div class="contact-us--content">
    <div class="contact-us--container">
<form action='https://forms.zohopublic.in/iudxcrm2/form/ContactUs1/formperma/oWgngX7leM1ACvLrI96SkVXz48OR6yb332ptydNA_1A/htmlRecords/submit' name='form' id='form' method='POST' accept-charset='UTF-8' enctype='multipart/form-data' (submit)="onZohoFormSubmit($event)">
  <input type="hidden" name="zf_referrer_name" value=""><!-- To Track referrals , place the referrer name within the " " in the above hidden input field -->
  <input type="hidden" name="zf_redirect_url" [value]="thankYouRedirectUrl"><!-- Redirect after submit: uses current origin so production stays on production -->
  <input type="hidden" name="zc_gad" value=""><!-- If GCLID is enabled in Zoho CRM Integration, click details of AdWords Ads will be pushed to Zoho CRM -->
  <h2>Contact Us</h2>
  <p></p>
  <label>
  Full Name
  <em>*</em>
  </label>
  <div class="contact-us--form-row">
    <div class="contact-us--field">
      <label>First Name</label>
      <input type="text" maxlength="255" name="Name_First" fieldType=7 placeholder="" [value]="prefillFirstName" [readonly]="!!prefillFirstName" />
    </div>
    <div class="contact-us--field">
      <label>Last Name</label>
      <input type="text" maxlength="255" name="Name_Last" fieldType=7 placeholder="" [value]="prefillLastName" [readonly]="!!prefillLastName" />
    </div>
  </div>
  <label>
  Email
  <em>*</em>
  </label>
  <input type="text" maxlength="255" name="Email" fieldType=9 placeholder="" [value]="prefillEmail" [readonly]="!!prefillEmail" />
  <label>
  Tell us more about your requirement
  <em>*</em>
  </label>
  <textarea
    name="MultiLine"
    maxlength="65535"
    placeholder=""
    required
    [class.contact-us--zoho-field-error]="!!zohoFormMultiLineError"
    (input)="onZohoMultiLineInput()"
  ></textarea>
  @if (zohoFormMultiLineError) {
    <p class="contact-us--zoho-inline-error">{{ zohoFormMultiLineError }}</p>
  }
  <button type="submit"><em>Submit</em></button></form>
    </div>
  </div>
</section>
<app-footer></app-footer>
